// extracted by mini-css-extract-plugin
export default {"container":"SourceName_container__WUPQs","icon_container":"SourceName_icon_container__3_nw7","icon":"SourceName_icon__1DcXQ","content":"SourceName_content__1Q-6X"};